import {
  Fingerprint, PlugZap, LayoutDashboard, FileSearch, Bot, Boxes, History, ShieldAlert, FileCode2, Rocket, Briefcase, Images,
} from "lucide-react";

export const CONCEPTS = [
  { id: "c03", num: "03", src: "/concepts/c03_executive_os.jpg", key: "gal.c03" },
  { id: "c04", num: "04", src: "/concepts/c04_intake_seal.jpg", key: "gal.c04" },
  { id: "c05", num: "05", src: "/concepts/c05_ai_workspace.jpg", key: "gal.c05" },
  { id: "c06", num: "06", src: "/concepts/c06_custody_ledger.jpg", key: "gal.c06" },
  { id: "c07", num: "07", src: "/concepts/c07_audit_timeline.jpg", key: "gal.c07" },
  { id: "c08", num: "08", src: "/concepts/c08_exception_center.jpg", key: "gal.c08" },
];

export const SCREENS = [
  { id: "auth", num: "01", key: "nav.auth", icon: Fingerprint, group: "access" },
  { id: "source", num: "02", key: "nav.source", icon: PlugZap, group: "access" },
  { id: "exec", num: "03", key: "nav.exec", icon: LayoutDashboard, group: "ops" },
  { id: "intake", num: "04", key: "nav.intake", icon: FileSearch, group: "ops" },
  { id: "ai", num: "05", key: "nav.ai", icon: Bot, group: "ops" },
  { id: "custody", num: "06", key: "nav.custody", icon: Boxes, group: "assurance" },
  { id: "audit", num: "07", key: "nav.audit", icon: History, group: "assurance" },
  { id: "exception", num: "08", key: "nav.exception", icon: ShieldAlert, group: "assurance" },
  { id: "matter", num: "09", key: "nav.matter", icon: Briefcase, group: "cases" },
  { id: "gallery", num: "10", key: "nav.gallery", icon: Images, group: "cases" },
  { id: "policy", num: "+", key: "nav.policy", icon: FileCode2, group: "advanced" },
  { id: "deploy", num: "+", key: "nav.deploy", icon: Rocket, group: "advanced" },
];

export const NAV_GROUPS = [
  { id: "access", key: "nav.group.access" },
  { id: "ops", key: "nav.group.ops" },
  { id: "assurance", key: "nav.group.assurance" },
  { id: "cases", key: "nav.group.cases" },
  { id: "advanced", key: "nav.group.advanced" },
];

export const QUICK_PROMPTS = {
  zh: [
    "分析号码 +1 206-493-3995 的异地登录风险",
    "这批证据能否直接用于出庭？请用通俗语言说明",
    "写一条禁止非 FIDO2 特权会话的 Rego 规则",
    "解释不可能旅行检测及其阈值调优",
  ],
  en: [
    "Assess impossible-travel risk for +1 206-493-3995",
    "Is this evidence set court-ready? Explain in plain language",
    "Write a Rego rule blocking non-FIDO2 privileged sessions",
    "Explain impossible-travel detection and how to tune it",
  ],
};

export const DEFAULT_REGO = `package veralix.aegis.authz

import future.keywords.if

default allow := false

# High-risk actions require a fresh, verified Steward FIDO2 assertion
allow if {
    input.action.risk == "HIGH_RISK"
    input.steward.fido2_verified == true
    input.steward.assertion_fresh_seconds < 120
}

# Read-only tool calls are permitted in the AI plane unless impossible travel is seen
allow if {
    input.action.scope == "read-only"
    not input.session.impossible_travel
}
`;

export const EMERGENT_PROMPT = `# Emergent Target Architecture — Option 2: Read-Only Resilient AI Plane
1. Deploy services/agent-runtime docker container to AWS ECS Fargate behind API Gateway.
2. Set environment variable AGENTIC_AI_ENABLED=true in the staging environment first.
3. Bind DynamoDB AgentRunMetadata table with versioned ConditionExpression writes.
4. Bind Amazon Bedrock Converse API with strict JSON-Schema output validation.
5. Connect Cognito User Pool with the WebAuthn / FIDO2 Step-Up Approval extension.
6. Host the SPA on CloudFront + S3; point VITE_AEGIS_API_GATEWAY_URL at the live route.`;

export const AWS_MAP = [
  { svc: "AWS ECS Fargate", role: "services/agent-runtime container behind API Gateway", state: "provisioned" },
  { svc: "DynamoDB · AgentRunMetadata", role: "Versioned ConditionExpression writes (non-loss)", state: "bound" },
  { svc: "Amazon Bedrock · Converse", role: "Strict JSON-Schema output validation", state: "active" },
  { svc: "AWS Cognito User Pool", role: "WebAuthn / FIDO2 Step-Up Approval", state: "enforcing" },
  { svc: "CloudFront + S3", role: "Veralix Aegis SPA static hosting", state: "live" },
];
